import {LayerManager, LayerRegisterInfo} from '../core';

export function registerModal(desirePriority?: number, preventStackOver?: boolean): LayerRegisterInfo {
	return LayerManager.register({desirePriority, preventStackOver, active: true});
}

export function deregisterModal(modalRegisterInfo: LayerRegisterInfo | Readonly<LayerRegisterInfo>): void {
	return LayerManager.deregister(modalRegisterInfo);
}
